<template>
  <div class="select-box-item">
    <ImageView v-if="image" class="image" :src="image" />
    <div>
      <div class="name">
        {{ name }}
        <div class="sub-name">
          {{ subName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import ImageView from "@/components/atoms/ImageView.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { ImageView },
  props: {
    id: String as PropType<string>,
    name: String as PropType<string>,
    subName: String as PropType<string>,
    image: String as PropType<string>,
  },
});

interface Props {
  id: string;
  name: string;
  subName: string;
  image?: string;
}

interface Data {}

interface Computed {}

interface Methods {}

export type SelectBoxItemProps = Props;
</script>

<style lang="scss" scoped>
.select-box-item {
  display: flex;
  align-items: center;

  .image {
    height: 50px;
    width: auto;
    margin-right: 20px;
  }

  .name {
    flex: 1;
    font-weight: var(--font-weight-bold);

    .sub-name {
      margin-top: 5px;
      font-size: 0.8em;
      color: var(--color-text-low);
    }
  }
}
</style>
